export class NumberInput {
    private $input: JQuery;
    public onChange?: { (value: number | undefined) };
    public onKeyPress?: { (value: number | undefined) };
    public onFocus?: { (hasFocus: boolean)}
    private isFloating: boolean = false;
    private config = {
        min: 1,
        max: Number.MAX_SAFE_INTEGER,
        step: 1,
        decimals: 0,
    };

    constructor($input?: JQuery, cfg?: object) {
        this.config = { ...this.config, ...cfg };

        if (this.config.decimals !== undefined && this.config.decimals > 0) this.isFloating = true;

        this.$input =
            $input === undefined
                ? $(
                      `<input type="number" min="${this.config.min}" max="${this.config.max}" step="${this.config.step}" class="form-control" />`
                  )
                : $input;

        this.$input.focus(() => {
            document.body.classList.add("keyboard");
            if (this.onFocus) {
                this.onFocus(true);
            }
        });
        
        this.$input.blur(() => {
            document.body.classList.remove("keyboard");
            if (this.onFocus) {
                this.onFocus(false);
            }
        });

        this.$input.change(() => {
            if (this.onChange !== undefined) this.onChange(this.getValue());
        });

        this.$input.on("input", () => {
            if (this.onKeyPress !== undefined) this.onKeyPress(this.getValue());
        });
    }

    public setVisibility(visible: boolean) {
        if (visible) {
            this.$input.show();
        } else {
            this.$input.hide();
        }
    }


    public getValue(): number | undefined {
        return this.$input.val().length !== 0
            ? this.isFloating
                ? parseFloat(this.$input.val())
                : parseInt(this.$input.val())
            : undefined;
    }

    public setValue(value?: number | string): NumberInput {
        if (this.isFloating && value !== undefined && typeof value == "number")
            value = (Math.round(value * 100) / 100).toFixed(this.config.decimals);

        this.$input.val(value === undefined ? "" : value);
        return this;
    }

    public setError(hasError: boolean): NumberInput {
        if (hasError) this.$input.addClass("is-invalid");
        else this.$input.removeClass("is-invalid");

        return this;
    }

    public setDisabled(isDisabled: boolean): NumberInput {
        this.$input.prop("disabled", isDisabled);

        return this;
    }

    public renderTo($element: JQuery): NumberInput {
        this.$input.appendTo($element);
        return this;
    }
}
